import(/* webpackMode: "eager" */ "D:\\Source\\Personal\\xoso\\xoso-client\\src\\app\\events\\page.tsx");
